import React, { Component } from 'react';
class CreditLimitModel extends Component {

    handleModelChange = (e, elementName,modelId) => {
        this.props.modelDataCallback(e.target.value,elementName,modelId)
    } 

   handleField=(p,index)=>{
    
        if(p.type !== "DROPDOWN"){
            if(p.elementName === "Credit_Limit_in_INR_Lacs"){
                return(
                    <p>{p.value}</p>
                )
            }
            else{
                return(
                    <input type="text" name={p.elementName+index}  className='form-control' defaultValue={p.value} key={p.value} onBlur={(e) => this.handleModelChange(e, p.elementName,this.props.modelId)}></input>
                )
            }
        }
        else{
            return(
                
                <select className="form-control" name={p.elementName+index} onBlur={(event) => this.handleModelChange(event, p.elementName,this.props.modelId)}>
                     <option value=''>Select</option>
                     {this.props.selectOptions[p.elementName].map(element => {
                          if(p.value === element){
                             return(<option key={element}  selected={p.value} value={element}>{element}</option>)
                          } 
                          else{
                            return(<option key={element} value={element}>{element}</option>)
                          }             
                     })
                    }

                </select>
                
            )
   }
   }

    
    render() {
        if (this.props.data) {
            return (
                this.props.data.map((p,index) => {
                    return (
                        < tr key={p.elementName} >
                        <td>
                            {p.displayName}
                        </td>
                        <td>
                            {this.handleField(p,index)}
                        </td>
                        </tr>
                    )
                })
            )
        }
    }
}
export default CreditLimitModel;